import api from "./index"

export const getEcommerceInfoService = async (params) =>
  await api.get(`/users/chleba/access-information`, { params });

export const getEcommerceLinkService = async (selectedEvent, selectedContract) =>
  await api.post(`/ecommerce/chleba/auth `, {
    eventId: selectedEvent, opportunityId: selectedContract
  });

export const getEcommerceProductsService = async (token) => {
  const configHeaders = {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  };

  return await api.patch(`/admin/ecommerce/chleba/product`, { status: true }, configHeaders);
}
